module.exports = __webpack_public_path__ + "img/Matteo Alessio Tambussi.61f19802.jpg";